import React from "react";
import PropTypes from "prop-types";
import { Form, Select, Option, Text } from "informed";
import ActionRequest from "contracts/requests/ActionRequest";
import { validateEmail, validateRequired } from "validators/validators";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";

class EYMagicLinkGenerator extends React.Component {
  static propTypes = {
    actions: PropTypes.array,
    actionSaveAction: PropTypes.func,
    magicLink: PropTypes.object,
    intl: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.magicLink.success === true) {
      this.formApi.reset();
    }
  }
  handleSubmit = event => {
    event.preventDefault();
    this.formApi.submitForm();

    if (!this.formApi.getState().invalid) {
      const actionRequest = new ActionRequest({
        email: this.formApi.getValue("email"),
        actionId: this.formApi.getValue("action")
      });
      this.props.actionSaveAction(actionRequest);
    }
  };
  setFormApi = formApi => {
    this.formApi = formApi;
  };
  render() {
    const intl = this.props.intl;
    return (
      <React.Fragment>
        <div className="columns">
          <div className="column">
            <div className="card">
              <div className="card-content">
                <div className="columns is-gapless">
                  <div className="column is-9">
                    <p className="title is-4">Welcome to MagicLink Generator</p>
                  </div>
                  <div className="column is-3">
                    <Link to="/user/mylinks">MyLinks</Link>
                  </div>
                </div>
                <Form id="complex-form" getApi={this.setFormApi}>
                  {({ formApi }) => (
                    <React.Fragment>
                      <div className="field">
                        <label className="label">Destination email</label>
                        <div className="control">
                          <Text
                            field="email"
                            id="input-text-email"
                            className={
                              this.formApi.getError("email")
                                ? "input is-danger"
                                : "input"
                            }
                            type="text"
                            placeholder="write your email"
                            maxLength="254"
                            validate={value => validateEmail(value, intl)}
                            validateOnBlur
                            validateOnChange
                          />
                          <p className="help is-danger is-pulled-right">
                            {this.formApi.getError("email")}
                          </p>
                        </div>
                      </div>
                      <div className="field">
                        <label className="label">Action to generate</label>
                        <div className="control">
                          <div
                            className={
                              this.formApi.getError("action")
                                ? "select is-danger"
                                : "select"
                            }
                          >
                            <Select
                              field="action"
                              id="select-duration"
                              validate={value => validateRequired(value, intl)}
                              validateOnChange
                            >
                              <Option value="" disabled>
                                Select One...
                              </Option>
                              {this.props.actions.map((method, index) => {
                                if (method != null) {
                                  let methodId = method.id;
                                  let methodName = method.name;
                                  return (
                                    <Option
                                      key={index.toString()}
                                      value={methodId.toString()}
                                    >
                                      {methodName.toString()}
                                    </Option>
                                  );
                                 }
                              })}
                            </Select>
                            <p className="help is-danger is-pulled-right">
                              {this.formApi.getError("action")}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="field is-grouped">
                        <div className="control">
                          <button
                            id="button-generate-link"
                            className="button is-primary"
                            onClick={event => this.handleSubmit(event)}
                          >
                            Create
                          </button>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default injectIntl(EYMagicLinkGenerator);
